// Metal Stud Configuration

export const APP_NAME = 'iMetalStud';
export const APP_VERSION = '1.0.0';
export const APP_VERSION_POLICY = { currentVersion: APP_VERSION };

import type { ChartImage, DropdownOption } from '../shared';

export type APIPayload = {
  title: string;
  L: number;
  W: string;
  addedWeight: string;
  supports: number;
  sectionName: string;
  numStuds: number;
  restraintLength: number;
  axialLoad: string;
  Pa: string; // pressure history csv
  td: string; // time history csv
  d0: number;
  v0: number;
};

export type ChartKey = 'ductility' | 'hysteresis' | 'load' | 'displacement' | 'rotation' | 'reaction';

// prettier-ignore
const StudSections = ['SSMA 400S137-33 (33ksi)', 'SSMA 400S137-43 (33ksi)', 'SSMA 400S137-54 (33ksi)', 'SSMA 400S137-68 (33ksi)','SSMA 400S162-33 (33ksi)', 'SSMA 400S162-43 (33ksi)',
                      'SSMA 400S162-54 (33ksi)', 'SSMA 400S162-68 (33ksi)', 'SSMA 400S200-33 (33ksi)', 'SSMA 400S200-43 (33ksi)', 'SSMA 400S200-54 (33ksi)', 'SSMA 400S200-68 (33ksi)',
                      'SSMA 600S137-33 (33ksi)', 'SSMA 600S137-43 (33ksi)', 'SSMA 600S137-54 (33ksi)', 'SSMA 600S137-68 (33ksi)', 'SSMA 600S137-97 (33ksi)', 'SSMA 600S162-33 (33ksi)',
                      'SSMA 600S162-43 (33ksi)', 'SSMA 600S162-54 (33ksi)', 'SSMA 600S162-68 (33ksi)', 'SSMA 600S162-97 (33ksi)', 'SSMA 600S200-33 (33ksi)', 'SSMA 600S200-43 (33ksi)',
                      'SSMA 600S200-54 (33ksi)', 'SSMA 600S200-68 (33ksi)', 'SSMA 600S200-97 (33ksi)', 'SSMA 600S250-43 (33ksi)', 'SSMA 600S250-54 (33ksi)', 'SSMA 600S250-68 (33ksi)',
                      'SSMA 600S250-97 (33ksi)', 'SSMA 800S137-33 (33ksi)', 'SSMA 800S137-43 (33ksi)', 'SSMA 800S137-54 (33ksi)', 'SSMA 800S137-68 (33ksi)', 'SSMA 800S137-97 (33ksi)',
                      'SSMA 800S162-33 (33ksi)', 'SSMA 800S162-43 (33ksi)', 'SSMA 800S162-54 (33ksi)', 'SSMA 800S162-68 (33ksi)', 'SSMA 800S162-97 (33ksi)', 'SSMA 800S200-33 (33ksi)',
                      'SSMA 800S200-43 (33ksi)', 'SSMA 800S200-54 (33ksi)', 'SSMA 800S200-68 (33ksi)', 'SSMA 800S200-97 (33ksi)', 'SSMA 800S250-43 (33ksi)', 'SSMA 800S250-54 (33ksi)',
                      'SSMA 800S250-68 (33ksi)', 'SSMA 800S250-97 (33ksi)', 'SSMA 1000S162-43 (33ksi)', 'SSMA 1000S162-54 (33ksi)', 'SSMA 1000S162-68 (33ksi)', 'SSMA 1000S162-97 (33ksi)',
                      'SSMA 1000S200-43 (33ksi)', 'SSMA 1000S200-54 (33ksi)', 'SSMA 1000S200-68 (33ksi)', 'SSMA 1000S200-97 (33ksi)', 'SSMA 1000S250-43 (33ksi)', 'SSMA 1000S250-54 (33ksi)',
                      'SSMA 1000S250-68 (33ksi)', 'SSMA 1000S250-97 (33ksi)', 'SSMA 1200S162-54 (33ksi)', 'SSMA 1200S162-68 (33ksi)', 'SSMA 1200S162-97 (33ksi)', 'SSMA 1200S200-54 (33ksi)',
                      'SSMA 1200S200-68 (33ksi)', 'SSMA 1200S200-97 (33ksi)', 'SSMA 1200S250-54 (33ksi)', 'SSMA 1200S250-68 (33ksi)', 'SSMA 1200S250-97 (33ksi)', 'SSMA 400S137-54 (50ksi)',
                      'SSMA 400S137-68 (50ksi)', 'SSMA 400S162-54 (50ksi)', 'SSMA 400S162-68 (50ksi)', 'SSMA 400S200-54 (50ksi)', 'SSMA 400S200-68 (50ksi)','SSMA 600S137-54 (50ksi)',
                      'SSMA 600S137-68 (50ksi)', 'SSMA 600S137-97 (50ksi)', 'SSMA 600S162-54 (50ksi)', 'SSMA 600S162-68 (50ksi)', 'SSMA 600S162-97 (50ksi)', 'SSMA 600S200-54 (50ksi)',
                      'SSMA 600S200-68 (50ksi)', 'SSMA 600S200-97 (50ksi)', 'SSMA 600S250-54 (50ksi)', 'SSMA 600S250-68 (50ksi)', 'SSMA 600S250-97 (50ksi)', 'SSMA 800S137-54 (50ksi)',
                      'SSMA 800S137-68 (50ksi)', 'SSMA 800S137-97 (50ksi)', 'SSMA 800S162-54 (50ksi)', 'SSMA 800S162-68 (50ksi)', 'SSMA 800S162-97 (50ksi)', 'SSMA 800S200-54 (50ksi)',
                      'SSMA 800S200-68 (50ksi)', 'SSMA 800S200-97 (50ksi)', 'SSMA 800S250-54 (50ksi)', 'SSMA 800S250-68 (50ksi)', 'SSMA 800S250-97 (50ksi)', 'SSMA 1000S162-54 (50ksi)',
                      'SSMA 1000S162-68 (50ksi)','SSMA 1000S162-97 (50ksi)', 'SSMA 1000S200-54 (50ksi)', 'SSMA 1000S200-68 (50ksi)', 'SSMA 1000S200-97 (50ksi)', 'SSMA 1000S250-54 (50ksi)',
                      'SSMA 1000S250-68 (50ksi)', 'SSMA 1000S250-97 (50ksi)', 'SSMA 1200S162-54 (50ksi)', 'SSMA 1200S162-68 (50ksi)', 'SSMA 1200S162-97 (50ksi)', 'SSMA 1200S200-54 (50ksi)',
                      'SSMA 1200S200-68 (50ksi)', 'SSMA 1200S200-97 (50ksi)', 'SSMA 1200S250-54 (50ksi)', 'SSMA 1200S250-68 (50ksi)', 'SSMA 1200S250-97 (50ksi)',
]

export const SECTION_NAMES: DropdownOption[] = StudSections.map(s => ({ value: s, label: s }));

export type APIResponse = {
  TA: number;
  Me: number;
  Xmax: number;
  tmax: number;
  Xmin: number;
  tmin: number;
  steel_weight: number;
  GWP: number;
  A: number;
  Av: number;
  I: number;
  S: number;
  Z: number;

  K: number[];
  Tn: number[];
  Ru: number[];
  Xe: number[];
  duct: number[];
  rot: number[];
  V1: number[];
  V2: number[];

  charts?: Partial<Record<ChartKey, ChartImage>>;
};

// ============================================================================
// RESPONSE DISPLAY CONFIGURATION
// ============================================================================

import type { SectionConfig } from '../shared';
import { createElement as h } from 'react';

/**
 * Configuration for displaying response data
 * Defines what fields to show and how to format them
 */
export const RESPONSE_DISPLAY_CONFIG: SectionConfig<APIResponse>[] = [
  {
    title: 'Results',
    fields: [
      { label: 'Tributary Area', getValue: data => h('span', null, data.TA.toFixed(2), ' ft', h('sup', null, '2')) },
      {
        label: 'Stiffness',
        getValue: data => `[ ${data.K.map(value => value.toFixed(2))} ] kip/in`
      },
      {
        key: 'Me',
        label: 'Effective Mass',
        getValue: data => h('span', null, data.Me.toFixed(2), 'lb-sec', h('sup', null, '2'), '/in')
      },
      {
        label: 'Natural Period',
        getValue: data => `[ ${data.Tn.map(value => value.toFixed(2))} ] msec`
      },
      {
        label: 'Resistance (Reb/Inb)',
        getValue: data => `[ ${data.Ru.map(value => value.toFixed(2))} ] kips`
      },
      {
        label: 'Xe (Reb / Inb)',
        getValue: data => `[ ${data.Xe.map(value => value.toFixed(2))} ] in`
      },
      {
        label: 'Ductility (Reb / Inb)',
        getValue: data => `[ ${data.duct.map(value => value.toFixed(2))} ]`
      },
      {
        label: 'Rotation (Reb / Inb)',
        getValue: data => `[ ${data.rot.map(value => value.toFixed(2))} ] deg`
      },
      {
        label: 'Max Displacement',
        getValue: data => `${data.Xmax.toFixed(2)} in @ ${data.tmax.toFixed(2)} msec`
      },
      {
        label: 'Min Displacement',
        getValue: data => `${data.Xmin.toFixed(2)} in @ ${data.tmin.toFixed(2)} msec`
      }
    ]
  },
  {
    title: 'Other Results',
    fields: [
      {
        label: 'V1',
        getValue: data => `[ ${data.V1.map(value => value.toFixed(2))} ] kips`
      },
      {
        label: 'V2',
        getValue: data => `[ ${data.V2.map(value => value.toFixed(2))} ] kips`
      },
      {
        label: 'Self Weight',
        getValue: data => h('span', null, data.steel_weight.toFixed(2), ' lbs')
      },
      {
        label: 'GWP',
        getValue: data => h('span', null, data.GWP.toFixed(2), ' (kg CO2e)')
      },
      {
        label: 'A',
        getValue: data => h('span', null, data.A.toFixed(2), ' in', h('sup', null, '2'))
      },
      {
        label: 'Av',
        getValue: data => h('span', null, data.Av.toFixed(2), ' in', h('sup', null, '2'))
      },
      {
        label: 'I',
        getValue: data => h('span', null, data.I.toFixed(2), ' in', h('sup', null, '4'))
      },
      {
        label: 'S',
        getValue: data => h('span', null, data.S.toFixed(2), ' in', h('sup', null, '3'))
      },
      {
        label: 'Z',
        getValue: data => h('span', null, data.Z.toFixed(2), ' in', h('sup', null, '3'))
      }
    ]
  }
];
